import { LocalDate, LocalDateTime } from '@elio/shared/models';
import { toDate } from '../date.utils';

/**
 * Get the duration in milliseconds between dateTime1 and dateTime2. Return a negative integer if dateTime1 is after dateTime2.
 */
export const durationMillis = (dateTime1: LocalDate | LocalDateTime, dateTime2?: LocalDate | LocalDateTime): number => {
  const t1 = toDate(dateTime1);
  const t2 = dateTime2 ? toDate(dateTime2) : new Date();

  return t2.getTime() - t1.getTime();
};
